import Vue from 'vue'
import App from './App.vue'
import router from './router/routerSite.js'
import store from './store'
import Vuex from 'vuex'



Vue.config.productionTip = false;

Vue.use(Vuex)
window.$ = window.jQuery = require('jquery');

import 'bootstrap'

//bootstrapvue
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'
Vue.use(BootstrapVue);
import 'bootstrap-vue/dist/bootstrap-vue.css'
//end
//Sweet alert
import VueSweetalert2 from 'vue-sweetalert2';
Vue.use(VueSweetalert2);
import 'sweetalert2/dist/sweetalert2.min.css';
//End of sweet alert
import VueSmoothScroll from 'vue2-smooth-scroll'
import '@fortawesome/fontawesome-free/css/all.css';

Vue.use(VueSmoothScroll)
//End of toggle buttion

new Vue({
    el: '#app',
    router,
    store,
    
    render: h => h(App)
}).$mount('#app')

